import { APP_CONFIG } from '@/constants/app-config';
import { PATHS } from '@/constants/page-paths';
import {
  apiForgotPassword,
  apiRegister,
  apiResetPassword,
  // apiSignIn,
  apiSignOut,
  apiVerifyEmail,
} from '@/services/auth.api';

import { useChatStore, useTokenStore, useUserStore } from '@/store';
import { UseSignOutProps } from '@/types/others';

import { useCallback } from 'react';

import { useMutation } from 'react-query';

import { useNavigate } from 'react-router-dom';

import useUrlParams from './useParams';
import { apiSignIn } from '@/services/auth.admin.api';

export const useAuth = () => {
  const { token, setToken } = useTokenStore();
  const {setMessages} = useChatStore();
  const { setAuthenticated, setUser, isAuthenticated } = useUserStore();
  const navigate = useNavigate();
  const params = useUrlParams();

  const signInUser = useCallback(
    (data: Record<string, unknown>) => {
      const { token, is2faEnabled, ...userInfo } = data || {};
      if (!is2faEnabled) {
        setToken(token as string);
        setAuthenticated(true);
        setUser(userInfo);
        const persistedRedirectUrl = localStorage.getItem('redirectUrl');
        const redirectUrl =
          params.get(APP_CONFIG.REDIRECT_URL_KEY) || persistedRedirectUrl;
        navigate(redirectUrl ? redirectUrl : APP_CONFIG.authenticatedEntryPath);
      }
    },
    [navigate, params, setAuthenticated, setToken, setUser]
  );

  const {
    mutateAsync: signIn,
    isLoading: isSignInPending,
    ...singInData
  } = useMutation({
    mutationFn: apiSignIn,
    onSuccess: (res) => {
      signInUser(res?.data?.data);
    },
  });

  const {
    mutateAsync: logOut,
    isLoading: isSingOutPending,
    ...signOutData
  } = useMutation({
    mutationFn: apiSignOut,
    onSuccess: () => {
      setToken(null);
    },
  });
  // const signOut = useCallback(
  //   async ({
  //     apiCall = true,
  //     state,
  //     redirect,
  //     enableRedirect = true,
  //   }: UseSignOutProps = {}) => {
  //     localStorage.removeItem('redirectUrl');
  //     if (apiCall) {
  //       await logOut();
  //     } else {
  //       setToken(null);
  //     }
  //     setAuthenticated(false);
  //     setUser(null);
  //     if (enableRedirect) {
  //       navigate(redirect ?? PATHS.SIGN_IN, { replace: true, state });
  //     }
  //   },
  //   [logOut, navigate, setAuthenticated, setToken, setUser]
  // );

  const signOut = useCallback(
    async ({
      // apiCall = true,
      state,
      redirect,
      enableRedirect = true,
    }: UseSignOutProps = {}) => {
      localStorage.removeItem('redirectUrl');
      // if (apiCall) {
      //   await logOut();
      // } else {
      //   setToken(null);
      // }
      setToken(null)
      setMessages(() => []);
      setAuthenticated(false);
      setUser(null);
      if (enableRedirect) {
        navigate(redirect ?? PATHS.SIGN_IN, { replace: true, state });
      }
    },
    [ navigate, setAuthenticated, setToken, setUser, setMessages]
  );

  const registerUser = useMutation({
    mutationFn: apiRegister,
  });

  const {
    mutateAsync: verifyEmail,
    isLoading: isVerifyPending,
    ...verifyData
  } = useMutation({
    mutationFn: apiVerifyEmail,
  });

  const forgotPassword = useMutation({
    mutationFn: apiForgotPassword,
  });

  const resetPassword = useMutation({
    mutationFn: apiResetPassword,
  });

  return {
    singInData,
    signIn,
    isSignInPending,
    isAuthenticated,
    token,
    isSingOutPending,
    signOut,
    signOutData,
    registerUser,
    verifyEmail,
    isVerifyPending,
    verifyData,
    forgotPassword,
    resetPassword,
    signInUser,
  };
};
